import React, {Component} from 'react';
import ReactDOM from 'react-dom';

import { Layout, MinMaxLayout } from '../../layouts';
import AccessMain from './access-main';

class GrantsAccess extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Layout>
                <MinMaxLayout main={<AccessMain grantId={this.props.grantId}/>}/>
            </Layout>
        );
    }
}

const el = document.getElementById('grants-applications-access');

if (el) {
    ReactDOM.render(<GrantsAccess grantId={el.getAttribute('data-grant-id')}/>, el);
}
